import { ActionType } from './';

const textInput = (state = {},  action: ActionType) => {
  switch (action.type) {
    case 'TEXT_INPUT':
      return {
        ...state,
        focus: action.focusTextInput
      };
    default:
      return state
  }
}

export default textInput;



// WEBPACK FOOTER //
// ./src/reducers/textInput.ts